<template>
  <div class="attachment-box">
    <div class="attachment-icon">
      <font-awesome-icon icon="paperclip" />
    </div>
    <div class="attachment-content">
      <span class="attachment-name" @click="openAttachment">{{ attachment.name }}</span>
      <small class="attachment-extension" v-if="fileExtension">{{ fileExtension }}</small>
    </div>
    <button class="download-button" @click="downloadAttachment" title="Pobierz plik">
      <font-awesome-icon icon="download" />
    </button>
  </div>
</template>

<script>
import axios from "../../../axios";
import { openProtectedFile } from "../../../protectedFiles";

export default {
  name: "TheoryPracticeLessonAttachment",
  props: ["attachment"],
  computed: {
    fileExtension() {
      if (!this.attachment.filenameWithExtension) return null;
      const parts = this.attachment.filenameWithExtension.split('.');
      return parts.length > 1 ? `.${parts[parts.length - 1].toUpperCase()}` : '';
    }
  },
  methods: {
    // Ten sam endpoint co przycisk pobierania: katalog lessonsAttachments/
    // nie jest juz wydawany ze statyku, wiec plik idzie przez bramke
    // sprawdzajaca oplacone uczestnictwo w kursie.
    openAttachment() {
      const url = `/theoryPracticeWorkshopsLessons/${this.attachment.theoryPracticeWorkshopsLessonId}/attachments/${this.attachment.id}`;
      openProtectedFile(url, this.attachment.filenameWithExtension);
    },
    async downloadAttachment() {
      const url = `/theoryPracticeWorkshopsLessons/${this.attachment.theoryPracticeWorkshopsLessonId}/attachments/${this.attachment.id}`;
      const response = await axios.get(url, { responseType: "arraybuffer" });
      
      const downloadUrl = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = downloadUrl;
      link.setAttribute("download", `${this.attachment.filenameWithExtension}`);
      document.body.appendChild(link);
      link.click();
      window.URL.revokeObjectURL(downloadUrl);
    },
  },
};
</script>

<style scoped>
.attachment-box {
  display: flex;
  align-items: center;
  padding: 14px 18px;
  background: linear-gradient(145deg, #ffffff, #f8f4ef);
  border-radius: 12px;
  transition: all 0.3s ease;
  box-shadow: 0 2px 10px rgba(139, 90, 43, 0.08);
  border: 1px solid rgba(139, 90, 43, 0.1);
  position: relative;
  overflow: hidden;
}

.attachment-box:hover {
  box-shadow: 0 5px 15px rgba(139, 90, 43, 0.15);
  transform: translateY(-2px);
  border-color: rgba(139, 90, 43, 0.2);
}



.attachment-box:hover::before {
  opacity: 1;
}

.attachment-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  background-color: rgba(139, 90, 43, 0.1);
  border-radius: 8px;
  margin-right: 14px;
  color: #8B857D;
  transition: all 0.3s ease;
}

.attachment-box:hover .attachment-icon {
  background-color: rgba(139, 90, 43, 0.15);
  color: #8B857D;
}

.attachment-content {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.attachment-name {
  color: #333;
  font-weight: 500;
  font-size: 15px;
  cursor: pointer;
  transition: color 0.2s ease;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
}

.attachment-name:hover {
  color: #8B857D;
  text-decoration: underline;
}

.attachment-extension {
  color: #999;
  font-size: 12px;
  margin-top: 2px;
}

.download-button {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  background-color: transparent;
  border: none;
  border-radius: 8px;
  color: #8B857D;
  opacity: 0.7;
  cursor: pointer;
  transition: all 0.2s ease;
  margin-left: 10px;
}

.download-button:hover {
  background-color: rgba(139, 90, 43, 0.15);
  color: #8B857D;
  opacity: 1;
}

@media (max-width: 768px) {
  .attachment-box {
    padding: 12px 14px;
  }
  
  .attachment-icon,
  .download-button {
    width: 32px;
    height: 32px;
  }
}
</style>